/*
https://www.facebook.com/
https://www.instagram.com/?hl=en
https://twitter.com/?lang=en

* Copyright (c) 2021. by N-Ach (Pvt) Ltd
*
* ╔═╗ ╔╗    ╔═══╗  ╔╗
* ║║╚╗║║    ║╔═╗║  ║║
* ║╔╗╚╝║    ║║ ║╠══╣╚═╗
* ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
* ║║ ║║║╚══╝║╔═╗║╚═╣║║║
* ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
*
* All rights reserved.
*
* This software is the confidential and proprietary information
* of N-Ach (Pvt) Ltd. ("Confidential Information"). You
* shall not disclose such Confidential Information and shall use
* it only in accordance with the terms of the license agreement
* you entered into with N-Ach (Pvt) Ltd.
*
*
* @Author Shalani Chethana
* @Date 24/03/2025
*/

import React from 'react'
import { Button, Container, Grid, Typography } from '@mui/material';
import Styles from './productsIntro.module.css';
import ProductBackGround from '../../assets/images/product/productCover-BlackBox3.png';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';

const ESERVICE = () => {

  return (

    <>
      <div className={Styles.topContentMainContainerEservices}>
        <img src={ProductBackGround} className={Styles.productCoverBlackBox} />
        <div className={Styles.topContentBox}>
          <Typography variant='h2' className={Styles.productTopHeader} >E Services</Typography>
          <Typography variant='h6' className={Styles.productTopBody}>Welcome to N-ACH advanced E-Services System,
            the all-in-one solution that empowers individuals and businesses to streamline their processes, enhance
            efficiency, and embrace the digital era. Feel free to tailor this product description according to the
            specific features, benefits, and branding of your E-Services System.</Typography>
        </div>
      </div>

      <div className={Styles.outerContainer}>
        <Typography variant='h5' className={Styles.titelFirsttxt} >KEY FEATURES</Typography>
        <div className={Styles.descriptionContainer}>

          <div>
            <div className={Styles.descriptionItem}>
              <AutoStoriesIcon className={Styles.bullet} />
              <div>
                <Typography className={Styles.descriptionTopic}>Seamless Online Experience:</Typography>
                <Typography className={Styles.descriptionText}>
                  Access a comprehensive suite of e-services conveniently from anywhere, at any time. Our platform offers a user-friendly interface that ensures a seamless online experience for all users.
                </Typography>
              </div>
            </div>

            <div className={Styles.descriptionItem}>
              <AutoStoriesIcon className={Styles.bullet} />
              <div>
                <Typography className={Styles.descriptionTopic}>Customizable Service Packages:</Typography>
                <Typography className={Styles.descriptionText}>
                  Tailor the services to match your specific needs. Choose from a range of customizable packages designed to cater to individuals, small businesses, or large enterprises.
                </Typography>
              </div>
            </div>

            <div className={Styles.descriptionItem}>
              <AutoStoriesIcon className={Styles.bullet} />
              <div>
                <Typography className={Styles.descriptionTopic}>Secure and Encrypted Transactions:</Typography>
                <Typography className={Styles.descriptionText}>
                  Trust is our priority. Rest assured that all transactions and interactions within our system are securely encrypted, maintaining the confidentiality and integrity of your data.
                </Typography>
              </div>
            </div>

            <div className={Styles.descriptionItem}>
              <AutoStoriesIcon className={Styles.bullet} />
              <div>
                <Typography className={Styles.descriptionTopic}>Efficient Document Management:</Typography>
                <Typography className={Styles.descriptionText}>
                  Say goodbye to paperwork. Our E-Services System allows you to upload, store, and manage your documents digitally. Access them with ease and never worry about misplacing important information again.
                </Typography>
              </div>
            </div>
          </div>

          <div>
            <div className={Styles.descriptionItem}>
              <AutoStoriesIcon className={Styles.bullet} />
              <div>
                <Typography className={Styles.descriptionTopic}>Automated Notifications and Reminders:</Typography>
                <Typography className={Styles.descriptionText}>
                  Stay on top of your tasks with our automated notification system. Receive timely alerts and reminders for appointments, deadlines, payments, and more, ensuring you never miss a beat.
                </Typography>
              </div>
            </div>

            <div className={Styles.descriptionItem}>
              <AutoStoriesIcon className={Styles.bullet} />
              <div>
                <Typography className={Styles.descriptionTopic}>Diverse Service Offerings:</Typography>
                <Typography className={Styles.descriptionText}>
                  Explore a wide range of e-services, including e-payments, online bookings, virtual consultations, e-learning, and more. Our platform caters to various needs, saving you time and effort.
                </Typography>
              </div>
            </div>

            <div className={Styles.descriptionItem}>
              <AutoStoriesIcon className={Styles.bullet} />
              <div>
                <Typography className={Styles.descriptionTopic}>24/7 Customer Support:</Typography>
                <Typography className={Styles.descriptionText}>
                  Rest easy knowing that our dedicated customer support team is available around the clock to assist you. Whether you have inquiries or encounter challenges, we're here to help.
                </Typography>
              </div>
            </div>
          </div>


        </div>
      </div>
    </>




  );
}

export default ESERVICE;